import { render, staticRenderFns } from "./ForwardSpellMaker.vue?vue&type=template&id=df933678&scoped=true&"
import script from "./ForwardSpellMaker.vue?vue&type=script&lang=js&"
export * from "./ForwardSpellMaker.vue?vue&type=script&lang=js&"
import style0 from "./ForwardSpellMaker.vue?vue&type=style&index=0&id=df933678&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df933678",
  null
  
)

export default component.exports